export const INTEGRATION_CATALOG = {
    yotpo: {
        name: 'yotpo',
        category: 'loyalty',
        docUrl: 'https://getjust.eu/en/docs/yotpo-loyalty-referrals-integration-guide',
        syncable: true,
        testable: false,
    },
    'hey-pongo': {
        name: 'hey-pongo',
        category: 'loyalty',
        syncable: true,
        testable: false,
        supportedPlatforms: ['shopify'],
    },
    loyoly: {
        name: 'loyoly',
        category: 'loyalty',
        syncable: false,
        testable: false,
        supportedPlatforms: ['shopify'],
    },
    'colissimo-pickup-point': {
        name: 'colissimo-pickup-point',
        category: 'shipping',
        docUrl: 'https://getjust.eu/en/docs/colissimo-pickup-point-integration-guide',
        syncable: false,
        testable: false,
        supportedPlatforms: ['shopify'],
    },
    atlas: {
        name: 'atlas',
        category: 'shipping',
        syncable: true,
        testable: false,
        supportedPlatforms: ['shopify'],
    },
    addingwell: {
        name: 'addingwell',
        category: 'analytics',
        syncable: false,
        testable: true,
    },
    google: {
        name: 'google',
        category: 'analytics',
        syncable: false,
        testable: false,
    },
    facebook: {
        name: 'facebook',
        category: 'analytics',
        syncable: false,
        testable: true,
    },
    tiktok: {
        name: 'tiktok',
        category: 'analytics',
        syncable: false,
        testable: true,
    },
    pinterest: {
        name: 'pinterest',
        category: 'analytics',
        syncable: false,
        testable: false,
    },
    snapchat: {
        name: 'snapchat',
        category: 'analytics',
        syncable: false,
        testable: true,
    },
    'default-datalayer': {
        name: 'default-datalayer',
        category: 'analytics',
        syncable: false,
        testable: false,
    },
    'ab-tasty': {
        name: 'ab-tasty',
        category: 'analytics',
        syncable: false,
        testable: false,
    },
    contentsquare: {
        name: 'contentsquare',
        category: 'analytics',
        syncable: false,
        testable: false,
    },
    elevar: {
        name: 'elevar',
        category: 'analytics',
        syncable: false,
        testable: false,
    },
    'tag-install': {
        name: 'tag-install',
        category: 'analytics',
        syncable: false,
        testable: false,
    },
    analyzify: {
        name: 'analyzify',
        category: 'analytics',
        syncable: false,
        testable: false,
    },
    stape: {
        name: 'stape',
        category: 'analytics',
        syncable: false,
        testable: false,
    },
    sendcloud: {
        name: 'sendcloud',
        category: 'shipping',
        syncable: false,
        testable: true,
        supportedPlatforms: ['shopify'],
    },
    'mondial-relay': {
        name: 'mondial-relay',
        category: 'shipping',
        syncable: false,
        testable: true,
        supportedPlatforms: ['shopify'],
    },
};
//# sourceMappingURL=registry.js.map